// Types
export default Object.freeze({
  MAIL_SEND: 'Contacts/MAIL_SEND',
  RESET_STATUS: 'Contacts/RESET_STATUS',
});
